import { postKakaoLogin } from 'hooks/RQuery/service/auth';
import useSessionStorage from 'hooks/useSessionStorage';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { kakaoLoginUrl, request } from 'service/common';

export default function KakaoRedirect() {
  const code = new URL(window.location.href).searchParams.get('code');
  const navigate = useNavigate();
  const { set: roleSet } = useSessionStorage('role');
  const { set: memberIdSet } = useSessionStorage('memberId');
  const { set: nameSet } = useSessionStorage('name');
  const { set: tokenSet } = useSessionStorage('token');
  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (token) {
      navigate('/', { replace: true });
      return;
    }
    postKakaoLogin({ code, redirectUri: kakaoLoginUrl })
      .then((data) => {
        tokenSet(data.accessToken);
        memberIdSet(data.memberId);
        nameSet(data.name);
        roleSet(data.role);
        // interceptor 작업 (토큰)
        request.interceptors.request.use((config) => {
          config.headers['Authorization'] = data.accessToken;
          return config;
        });
        navigate('/', { replace: true });
      })
      .catch((e) => {});
  }, []);
  return <div>카카오 로그인 중...</div>;
}
